import { JwtVerifiedCredential } from '@dynamic-labs/sdk-api';
import { UserProfile } from '@dynamic-labs/sdk-react-core';
import { useMemo } from 'react';

/**
 * Custom hook to check if the user has a non-ZeroDev and non-Dynamic wallet.
 * @function useHasNonZeroDevAndDynamicWallet
 * @param {UserProfile | undefined} user - The user profile.
 * @returns {string | null} The address of the non-ZeroDev and non-Dynamic wallet, or null if not found.
 */
export const useHasNonZeroDevAndDynamicWallet = (
  user: UserProfile | undefined,
) => {
  return useMemo(
    () =>
      (user?.verifiedCredentials as JwtVerifiedCredential[]).find(
        (cred: JwtVerifiedCredential) =>
          cred.address !== undefined &&
          cred.walletName !== 'zerodev' &&
          cred.walletName !== 'turnkeyhd' &&
          cred.walletName !== 'dynamicwaas',
      )?.address || null,
    [user?.verifiedCredentials],
  );
};
